import classNames from "classnames";
import React from "react";
import KuikaSvg from "../kuika-svg/kuika-svg";
import "./kuika-modal-icon-wrapper.scss";

/**
 * What the dialog asks the user to do. The badge's colour follows from it — and matches the dialog's
 * primary button — so a caller picks a meaning, never a colour:
 *
 * - `create` (blue) — make something new: a folder, a name, a token.
 * - `edit` (purple) — change something that exists: rename, edit, move.
 * - `destructive` (red) — lose something: delete, revoke, unlink, discard.
 * - `warning` (yellow) — proceed with a risk: unsaved changes, overwrite, a large export.
 * - `success` (green) — something finished. Not for "create": green means done, not about to be.
 * - `neutral` (grey) — neither good nor bad: hand over ownership, pick a process.
 */
export type KuikaModalIconIntent = "create" | "edit" | "destructive" | "warning" | "success" | "neutral";

export interface IKuikaModalIconWrapperProps {
  iconName: string;
  iconType?:
    | "topbar-icons"
    | "common"
    | "datasource-icons"
    | "sidebar-icons"
    | "styling-panel-icons"
    | "action-icons"
    | "arrows"
    | "flags";
  intent: KuikaModalIconIntent;
  /** Explicit glyph size. Unset, the icon tile sizes the glyph (32px on its 64px tile). */
  iconWidth?: number;
  iconHeight?: number;
}

const KuikaModalIconWrapper: React.FC<IKuikaModalIconWrapperProps> = ({
  iconName,
  iconType = "common",
  intent,
  iconWidth,
  iconHeight
}) => {
  const hasCustomIconSize: boolean = iconWidth !== undefined || iconHeight !== undefined;

  return (
    <div className={`kuika-modal-icon-wrapper kuika-modal-icon-wrapper--${intent}`}>
      <div
        className={classNames("kuika-modal-icon-wrapper__icon", {
          "kuika-modal-icon-wrapper__icon--custom-size": hasCustomIconSize
        })}
      >
        <KuikaSvg
          type={iconType}
          name={iconName}
          width={iconWidth ?? iconHeight}
          height={iconHeight ?? iconWidth}
          color="var(--kuika-modal-icon-fg)"
          draw
        />
      </div>
    </div>
  );
};

export default KuikaModalIconWrapper;
